import {baseGetRequest} from "../base/baseGetRequest";

const consolePinIsActive = async () =>
  baseGetRequest<number>("/user_pin/console_pin_is_active/");

export default consolePinIsActive;
